module.exports = __webpack_public_path__ + "static/ObjectSans-Slanted-eae729419a1e5aafff335a16944d6313.otf";